export const TOPBAR_HEIGHT = '6.4rem';

export const SIDEBAR_WIDTH = '3.63rem';
export const SIDEBAR_WIDE_WIDTH = '7.2rem';

export const SIDEBAR_COLLAPSED_ZINDEX = 1299; // when Sidebar collapsed - decrease zIndex
